'use strict';

/*
    <div field-form class="row">

        <field-image-storage title="'Image'" value="data.imagekey" default-image="link"
            origin-type="'member'" origin-id="5" image-only="true" square-thumbnail="true">
        </field-image-storage>

    </div>

    // or field for js form
        {
            name: 'imagekey',
            title: 'Image',
            type: 'field',
            field: 'image-storage',
            option: {
                originType: "member",
                originId: originId,
                imageOnly: true
                squareThumbnail: true
                defaultImage: 'link'
            }
        },
*/

(function() {
    function link(DI) {
        var $scope = DI.$scope;
        $scope.field = {
            value: null
        };

        DI.prop(['title', 'originType', 'originId', 'imageOnly', 'defaultImage', 'squareThumbnail']);
        var setter = DI.prop('value', function(value) {
            $scope.field.value = value;
        }, {setter: true});

        $scope.change = function() {
            var option = {};
            if($scope.originType) {option.originType=$scope.originType;}
            if($scope.originId) {option.originId=$scope.originId;}
            if($scope.imageOnly) {option.imageOnly=$scope.imageOnly;}
            if($scope.squareThumbnail) {option.squareThumbnail=$scope.squareThumbnail;}
            DI.fileManager.chooseFile(option).then(function(file) {
                $scope.field.value = file.key;
                setter(file.key);
            });
        };

        $scope.reset = function() {
            $scope.field.value = null;
            setter(null);
        };

        $scope.imageLink = function() {
            if($scope.field.value) {
                return DI.fileManager.fileLinkByKey($scope.field.value, 50);
            }
            return $scope.defaultImage || null;
        };
    }

    gs.component('fieldImageStorage', {
        templateUrl: '/components/field/image-storage/field.image.html',
        link: link
    });

    gs.component('fieldImageStorageNoFrame', {
        templateUrl: '/components/field/image-storage/field.image.noframe.html',
        link: link
    });
})();
